import React from 'react';
import { CheckCircleIcon, ClockIcon } from '@heroicons/react/24/outline';

const PlanningProgress = ({ title, steps, loading = false }) => {
  if (loading) {
    return (
      <div className="bg-succession-bg-primary shadow-succession-md rounded-lg p-6 animate-pulse border border-succession-border transition-theme">
        <div className="h-6 bg-succession-bg-tertiary rounded w-3/4 mb-4 transition-theme"></div>
        <div className="space-y-4">
          {[1, 2, 3].map((_, index) => (
            <div key={index} className="flex items-start">
              <div className="flex-shrink-0">
                <div className="h-6 w-6 bg-succession-bg-tertiary rounded-full transition-theme"></div>
              </div>
              <div className="ml-3 w-full">
                <div className="h-4 bg-succession-bg-tertiary rounded w-3/4 transition-theme"></div>
                <div className="mt-2 h-2 bg-succession-bg-tertiary rounded w-1/2 transition-theme"></div>
              </div>
            </div>
          ))}
        </div>
        <div className="mt-4">
          <div className="h-4 bg-succession-bg-tertiary rounded w-full transition-theme"></div>
          <div className="mt-2 h-2 bg-succession-bg-tertiary rounded w-full transition-theme"></div>
        </div>
      </div>
    );
  }

  // Calculate overall progress as the average of all step percentages
  const overallProgress = steps.reduce((acc, step) => acc + (step.completionPercentage || 0), 0) / steps.length;

  return (
    <div className="bg-succession-bg-primary shadow-succession-md rounded-lg p-6 border border-succession-border transition-theme">
      <h3 className="text-lg font-medium text-succession-text-primary mb-4 transition-theme">{title}</h3>
      <div className="space-y-4">
        {steps.map((step, index) => (
          <div key={index} className="flex flex-col">
            <div className="flex items-start">
              <div className="flex-shrink-0">
                {step.completed ? (
                  <CheckCircleIcon className="h-6 w-6 text-succession-success transition-theme" />
                ) : (
                  <ClockIcon className="h-6 w-6 text-succession-text-muted transition-theme" />
                )}
              </div>
              <div className="ml-3 flex-grow">
                <div className="flex justify-between items-center">
                  <p className={`text-sm font-medium transition-theme ${step.completed ? 'text-succession-text-primary' : 'text-succession-text-secondary'}`}>
                    {step.label}
                  </p>
                  <span className="text-xs font-medium text-succession-text-secondary transition-theme">
                    {step.completionPercentage || 0}%
                  </span>
                </div>
                <div className="mt-1 w-full bg-succession-bg-tertiary rounded-full h-1.5 transition-theme">
                  <div
                    className="bg-succession-primary h-1.5 rounded-full transition-theme"
                    style={{ width: `${step.completionPercentage || 0}%` }}
                  ></div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-6">
        <div className="relative pt-1">
          <div className="flex mb-2 items-center justify-between">
            <div>
              <span className="text-xs font-semibold inline-block py-1 px-2 uppercase rounded-full text-succession-primary bg-succession-primary-10 transition-theme">
                Overall Progress
              </span>
            </div>
            <div className="text-right">
              <span className="text-xs font-semibold inline-block text-succession-primary transition-theme">
                {Math.round(overallProgress)}%
              </span>
            </div>
          </div>
          <div className="overflow-hidden h-2 mb-2 text-xs flex rounded bg-succession-primary-10 transition-theme">
            <div
              style={{ width: `${overallProgress}%` }}
              className="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-succession-primary transition-theme"
            ></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlanningProgress; 